<template>
  <div class="input-group">
    <datepicker v-model="localValue" format="yyyy-MM-dd" input-class="form-control"></datepicker>
    <span class="input-group-addon"><i class="fa fa-times pointer" v-on:click="clearDate()"></i></span>
  </div>

</template>

<script>
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'date-picker',

    props: ['value'],

    components: {
      Datepicker
    },

    data() {
      return {
        localValue: this.value
      }
    },

    methods: {
      clearDate() {
        this.localValue = null;
      }
    },
    watch: {
      localValue (val) {
        this.$emit('input', val);
      },
      value (val) {
        this.localValue = val;
      }
    }

  }

</script>